"use client";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { ScrollArea } from "../../components/ui/scroll-area";
import { X } from "lucide-react";

export default function SubitemsModal({ subitems, onClose }) {
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[9999] animate-fadeIn">
      <Card
        className="shadow-2xl transform transition-all duration-500 animate-scaleIn relative z-[10000]"
        style={{
          borderTop: "4px solid var(--color-secondary)",
          borderRadius: "24px",
          backgroundColor: "white",
          maxWidth: "700px",
          width: "90%",
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <CardHeader
          className="bg-gradient-to-r from-gray-50 to-white pb-4 relative"
          style={{ borderRadius: "24px 24px 0 0" }}
        >
          <CardTitle
            className="text-2xl font-bold"
            style={{ color: "var(--color-secondary)" }}
          >
            Detalles del Item
          </CardTitle>
          <CardDescription className="text-gray-600 text-base">
            Lista de elementos asociados a este item.
          </CardDescription>
          <Button
            variant="ghost"
            onClick={onClose}
            className="absolute top-4 right-4 p-2 rounded-full hover:bg-gray-100"
          >
            <X className="h-5 w-5 text-gray-500" />
          </Button>
        </CardHeader>
        <CardContent className="pt-6 flex-grow overflow-hidden">
          {subitems && subitems.length > 0 ? (
            <ScrollArea className="h-full pr-4 -mr-4">
              <ul className="space-y-1">
                {subitems.map((subitem, index) => (
                  <li
                    key={subitem.id || index}
                    className="bg-gray-50 p-1 rounded shadow-sm flex flex-col sm:flex-row justify-between items-start sm:items-center gap-1"
                  >
                    <div>
                      <p className="font-semibold text-gray-800 text-sm">
                        {subitem.name ||
                          subitem.description ||
                          "Sub-item sin nombre"}
                      </p>
                      {subitem.quantity && (
                        <p className="text-xs text-gray-600">
                          Cantidad: {subitem.quantity} {subitem.unit || ""}
                        </p>
                      )}
                      {subitem.details && (
                        <p className="text-xs text-gray-500 mt-0.5">
                          {subitem.details}
                        </p>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            </ScrollArea>
          ) : (
            <div className="text-center text-gray-500 py-10">
              No hay sub-items disponibles para este elemento.
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
